export default function () {
    $.fn.clearBlur = function () {
        $(this).each(function (i, elem) {
            var $elem = $(elem),
                $parent = $elem.parent(),
                $img = $parent.find('img');
            if ($img.is('[data-lazy-src]')) return;

            // Reset height
            $elem.css('height', 'auto');
            $parent.css('height', 'auto');
            var height = $elem.height(),
                isOdd = height % 2,
                parentHeight = $parent.height(),
                parentOdd = parentHeight % 2;
            height = isOdd ? height - 1 : height;
            parentHeight = parentOdd ? parentHeight - 1 : parentHeight;
            $elem.css("height", height);
            $parent.css('height', parentHeight);
        });
    };
}
